export default __webpack_public_path__ + "static/media/undraw_instant_information_6755 (2).3c387ee1.svg";